const phone = '58606820'
const email = 'jforce.sn@jumia.com'

const supportedLanguages = ['fr']
const personalInfo = {
  phoneNumberMask: '### #### ###'
}
const paymentMethods = {
  bankAccountMask: '### ### ####'
}

export {
  // auxiliary objects
  phone,
  email,

  // languages
  supportedLanguages,

  // personal info
  personalInfo,

  // payment methods
  paymentMethods
}
